document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.related-video').forEach(section => {
        const slider = section.querySelector(".swiper")
        if(!slider.swiper && window.innerWidth <= 768) {
             new Swiper(slider, {
                slidesPerView: "auto",
                spaceBetween: 15,
                touchRatio: 1,
                threshold: 10,
                watchSlidesProgress: true
            });
        }
    })
});